/** @file nodeTransform: a joint's local transform under the entity root (position and rotation). */
import type { Quaternion, Vector3 } from '@babylonjs/core/Maths/math.vector.js';
import type { Profile } from '@zilo/pose3d-format/types/profile';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { PoseBuffer } from '@zilo/pose3d-pose/contract';
import { poseNodeOf } from '@zilo/pose3d-render-core/place/poseNodeOf';
import { worldPointOf } from '@zilo/pose3d-render-core/place/worldPointOf';
import { toBabylonQuat } from '@zilo/pose3d-runtime-babylon/camera/toBabylonQuat';
import { toBabylonVec3 } from '@zilo/pose3d-runtime-babylon/camera/toBabylonVec3';

/**
 * `position = toBabylonVec3(worldPointOf(pose, nodeIndex, offset, zScaleRotate))` (entity-relative; the root's
 * scaling applies zScaleView) and `rotation = toBabylonQuat(node quaternion)`.
 */
export function nodeTransform(pose: PoseBuffer, nodeIndex: number, offset: Vec3, profile: Profile, out: { position: Vector3; rotation: Quaternion }): void {
  toBabylonVec3(worldPointOf(pose, nodeIndex, offset, profile.zScaleRotate ?? 1), out.position);
  toBabylonQuat(poseNodeOf(pose, nodeIndex).q, out.rotation);
}
